import * as yup from 'yup'
import { ShippingType } from '../api/orders/orders'

export const shippingInfoSchema = yup.object({
	company: yup
		.string()
		.trim()
		.max(100, 'El nombre de la empresa no debe superar los 100 caracteres')
		.required('La empresa de envío es obligatoria')
		.nullable(),

	company_address: yup
		.string()
		.trim()
		.max(200, 'La dirección de la empresa no debe superar los 200 caracteres')
		.required('La dirección de la empresa es obligatoria')
		.nullable(),

	code: yup
		.string()
		.trim()
		.max(50, 'El código de envío no debe superar los 50 caracteres')
		.required('El código de envío es obligatorio')
		.nullable(),

	estimated_date: yup
		.number()
		.min(0, 'La fecha estimada no puede ser negativa')
		.required('La fecha estimada de entrega es obligatoria')
		.nullable(),

	type: yup
		.mixed<ShippingType>()
		.oneOf(
			Object.values(ShippingType),
			'El tipo de envío debe ser "payed" o "payment_on_delivery"'
		)
		.required('El tipo de envío es obligatorio')
		.nullable(),
})
